import { i18n } from 'i18n';
import {
  InactiveUserDto,
  PagedListOfUserDto,
  ProjectDisclaimer,
  TermsAndConditionsAcceptance,
  UpdateDisclaimerOneDayCommand,
  UpdateDisclaimerSevenDaysCommand,
  UpdateUserCommand, UpdateUserDto,
  UpdateUserTeamRolesCommand
} from './api';
import {
  PageParams,
  makeCreateMutation,
  makeGetQuery,
  makeListQuery,
  makeUpdateMutation
} from './useApi';

const USERS_KEY = 'users';
const DISCLAIMER_KEY = 'disclaimer';
export const TERMS_AND_CONDITIONS_KEY = 'terms-and-conditions';
export interface UsersQueryParams extends PageParams {
  searchTerm?: string | null;
  clientId?: string | null;
  teamId?: string | null;
  sortBy?: string | null;
  sortDescending?: boolean;
}

export const useUsersQuery = makeListQuery<UsersQueryParams, PagedListOfUserDto>(
  USERS_KEY,
  (api, params) => () => api.users.listUsers(params.page, params.pageSize, params.clientId, params.teamId, params.searchTerm, params.sortBy, params.sortDescending),
);

const USER_KEY = 'user';
export const useUserQuery = makeGetQuery<UpdateUserDto, string>(
  USER_KEY,
  (api, userId) => () => api.users.getUserDetail(userId),
);

export const useDisclaimerQuery = makeGetQuery<ProjectDisclaimer, string>(
  DISCLAIMER_KEY,
  (api, projectId) => () => api.users.getDisclaimerStatus(projectId),
);

export const useUpdateUserMutation = makeUpdateMutation<void, UpdateUserCommand>(
  USER_KEY, USERS_KEY,
  (api, userId) => (user) => api.users.updateUser(userId, user),
  () => i18n._('Info successfully updated'),
);

export const useAcceptDisclaimerSevenDaysMutation = makeUpdateMutation<void, UpdateDisclaimerSevenDaysCommand>(
  DISCLAIMER_KEY, null,
  (api, userId) => (command) => api.users.updateDisclaimerSevenDays(userId, command),
  () => i18n._('Disclaimer Accepted'),
);

export const useAcceptDisclaimerOneDayMutation = makeUpdateMutation<void, UpdateDisclaimerOneDayCommand>(
  DISCLAIMER_KEY, null,
  (api, userId) => (command) => api.users.updateDisclaimerOneDay(userId, command),
  () => i18n._('Disclaimer Accepted'),
);

export const useUpdateUserRolesMutation = makeUpdateMutation<void, UpdateUserTeamRolesCommand>(
  USER_KEY, USERS_KEY,
  (api, userId) => (roles) => api.users.updateUserTeamsRoles(userId, roles),
  () => i18n._('Permissions successfully updated'),
);

export const useTermsAndConditionsQuery = makeGetQuery<TermsAndConditionsAcceptance>(
  TERMS_AND_CONDITIONS_KEY,
  (api) => () => api.users.getTermsAndConditionsStatus(),
);

export const useAcceptTermsAndConditionsMutation = makeCreateMutation<void, void>(
  TERMS_AND_CONDITIONS_KEY,
  (api) => () => api.users.acceptTermsAndConditions(),
  () => i18n._('Terms and conditions accepted'),
);

const INACTIVE_USERS_KEY = 'inactive-users';
export const useInactiveUsersQuery = makeGetQuery<InactiveUserDto[]>(
  INACTIVE_USERS_KEY,
  (api) => () => api.users.getInactiveUsers(),
);

export const useSendInactiveUsersReportMutation = makeCreateMutation<void, void>(
  null,
  (api) => () => api.users.sendInactiveUsersReport(),
  () => i18n._('Inactive users report sent'),
);
